<template>
    <div id="VsBox">
        <audio id="music" src="@/assets/audios/open.mp3"></audio>
        <div class="VsBox-box">
            <div class="detail_left">
                <!-- 标题 -->
                <div class="title">
                    <div class="left_title">
                        <div class="back" @click="ClickBack()">
                            <img src="@/assets/images/battlePage/battleVS_title_back_btn_img.png" alt="">
                            <span style="font-size: 14px;  color: #878b91;">返回</span>
                        </div>
                        <div class="room_num">
                            房间编号:
                            <span>{{ itemInfo.draw_code }}</span>
                        </div>
                    </div>
                </div>
                <!-- 对战宝箱信息 -->
                <div class="open_box_list">
                    <template v-if="GameState == 2">
                        <div class="open_box end1" v-for="(item, index) in itemInfo.game_arena_box" :key="index"
                            @click="ClickHotBox(item)">
                            <div class="box"><img :src="item.cover | ImgRoute" alt="">
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="open_box" v-for="(item, index) in itemInfo.game_arena_box" :key="index"
                            @click="ClickHotBox(item)">
                            <div class="box"><img :src="item.cover | ImgRoute" alt="">
                            </div>
                        </div>
                    </template>
                </div>

                <div class="VS-core">
                    <!-- 动画播放的线 -->
                    <!-- <div class="Xian" v-show="GameState == '1'"></div> -->
                    <open-case v-for="(item, index) in ItemArr" @childByValue='childByValue' @fromChild="getChild"
                        :itemInfo="itemInfo" :status="itemInfo.status" :create_user_id="itemInfo.create_user_id"
                        :key="ArrIndex[index]" :InDex="index" :game_arena_id="$route.query.id" :content="item"
                        :game_arena_data='game_arena_data'>
                    </open-case>
                </div>
            </div>

            <div class="detail_right">
                <div class="title">
                    <span>{{ hotBoxName }}</span>
                </div>
                <div class="product_list">
                    <div class="product" v-for="(award, index) in hotBoxAwards" :class="award.lv | LvGuoLv">
                        <div class="MBX">
                            <p><img src="@/assets/images/PublicImg/JinBi.png" alt="">{{ award.bean }}</p>
                        </div>
                        <span class="tag">{{ award.dura_alias }}</span>
                        <img class="product_img" :src="award.cover" alt="">
                        <p>{{ award.name }}</p>
                    </div>
                </div>
            </div>
            <template v-if="user.id == win_user_id">
                <van-overlay :show="XZshow">

                    <div class="wrapper">
                        <div class="award_show">
                            <div class="title">
                                <span>恭喜获得</span>
                            </div>
                            <div class="product_list">
                                <div class="product" v-for="(award, index) in Treasure_box_prize"
                                    :class="award.lv | LvGuoLv" @click="SelectItem(award, index)" ref="Select">
                                    <div class="MBX">
                                        <p><img src="@/assets/images/PublicImg/JinBi.png" alt="">{{ award.bean }}</p>
                                    </div>
                                    <span class="tag">{{ award.dura_alias }}</span>
                                    <img class="product_img" :src="award.cover" alt="">
                                    <p>{{ award.name }}</p>
                                </div>
                            </div>

                            <div class="btn_ok">
                                <div class="btn" @click="CloseXZshow">
                                    <p>确定</p>
                                </div>
                                <div class="btn" @click="Postcash">
                                    <p>放弃</p>
                                    <span><img style="height: 15px; margin-top: 4px;" src="@/assets/images/new-ui/9coin.png" alt=""></span>
                                    <span style="margin-top: 1px;">{{ JiaZhi.toFixed(2) }}</span>
                                </div>
                            </div>

                        </div>
                    </div>
                </van-overlay>
            </template>
        </div>
    </div>
</template>

<script>
import {
    mapState,
    mapActions,
    mapMutations
} from 'vuex'
import {
    Arena_Detail,
    Arena_Recover,
    PersonalInfo,
} from "@/network/api.js"
import OpenCase from './components/OpenCase.vue'
export default {
    name: 'VsBox',
    data() {
        return {
            XZshow: false,
            itemInfo: {},
            Treasure_box_prize: [],
            win_user_id: 0,
            TreasureName: '',
            ItemArr: [],
            ArrIndex: [0, 1, 2, 3],
            ChangCiNum: 0,

            RouterId: 0,
            JieShuData: {},

            JieShu: '',

            GameState: '0',
            game_arena_data: {},

            ///选中的宝箱
            hotBoxName: "",
            hotBoxAwards: [],

            ///回收相关
            JiaZhi: 0,

        }
    },
    created() {
        this.RouterId = this.$route.query.id
        //this.GetArena_Detail()
        this.$root.eventHub.$on('vs_award_show', () => {
            this.OpenXZshow();
            this.Select_All();
        });
    },
    activated() {
        this.RouterId = this.$route.query.id
        this.GetArena_Detail()
    },
    filters: {
        ImgRoute(str) {
            if (str.indexOf(localStorage.getItem('static_file_url')) != -1) {
                return str
            } else {
                return localStorage.getItem('static_file_url') + str
            }
        },
        LvGuoLv(val) {
            if (val == '1') {
                return 'lv1'
            } else if (val == '2') {
                return 'lv2'
            } else if (val == '3') {
                return 'lv3'
            } else if (val == '4') {
                return 'lv4'
            } else if (val == '5') {
                return 'lv5'
            }
        },
    },
    methods: {
        ///对战返回
        ClickBack() {
            let str = '/BattlePage'
            this.$router.push({
                path: str
            }).catch(err => {
            })
        },
        ClickHotBox(item) {
            this.hotBoxName = item.name;
            this.hotBoxAwards = item.box_award;
        },
        GetArena_Detail() {
            Arena_Detail(this.$route.query.id).then((res) => {
                this.ClickHotBox(res.data.data.game_arena_box[0]);

                this.Treasure_box_prize.length = 0;
                for (let i = 0; i < res.data.data.game_arena_player.length; i++) {
                    let player = res.data.data.game_arena_player[i];
                    for (let j = 0; j < player.game_award.length; j++) {
                        this.Treasure_box_prize.push(player.game_award[j].box_award);
                    }
                }
                //console.log(res.data.data);
                this.win_user_id=0;
                if (res.data.data.win_user_id) {
                    if(res.data.data.win_user_id.length < 2)
                        this.win_user_id = res.data.data.win_user_id[0];
                    else
                        this.win_user_id =0;
                }

                if (res.data.data.status == 0) {    ////房间等待状态
                    this.GameState = '0';
                    this.itemInfo = res.data.data;

                    let Arr = []
                    for (let i = 0; i < Number(this.itemInfo.user_num); i++) {
                        Arr[i] = undefined;
                    }
                    for (let k = 0; k < this.itemInfo.game_arena_player.length; k++) {
                        Arr[Number(this.itemInfo.game_arena_player[k].seat)] = this.itemInfo.game_arena_player[k]
                    }
                    this.ItemArr = Arr;
                }
                else if (res.data.data.status == 1) {

                }
                else if (res.data.data.status == 2) {   ///房间结束状态
                    if (this.$route.query.Code == 2) {  ///进入结果页面
                        this.GameState = '2'
                        this.itemInfo = res.data.data

                        let Arr = []
                        for (let i = 0; i < Number(this.itemInfo.user_num); i++) {
                            Arr[i] = undefined
                        }
                        for (let k = 0; k < this.itemInfo.game_arena_player.length; k++) {
                            Arr[Number(this.itemInfo.game_arena_player[k].seat)] = this.itemInfo.game_arena_player[k]
                        }

                        this.ItemArr = Arr
                        this.ChangCiNum = Number(res.data.data.box_num) - 1

                    }
                    else if (this.$route.query.Code == 1) { ////回放页面
                        this.GameState = '1'
                        this.itemInfo.box_num = res.data.data.box_num
                        this.itemInfo.total_bean = res.data.data.total_bean
                        let Arr = []

                        for (let i = 0; i < Number(res.data.data.user_num); i++) {
                            Arr[i] = undefined
                        }

                        for (let k = 0; k < res.data.data.game_arena_player.length; k++) {
                            Arr[Number(res.data.data.game_arena_player[k].seat)] = res.data.data.game_arena_player[k]
                        }

                        this.ItemArr = Arr

                        this.ChangCiNum = Number(res.data.data.box_num) - 1
                        this.game_arena_data = res.data.data
                        this.itemInfo.status = res.data.data.status
                        this.itemInfo.game_arena_box = res.data.data.game_arena_box
                    }

                }


            })
        },


        getChild(val) {
            if (val.id == this.$route.query.id) {
                this.ChangCiNum = val.Draw_times
                this.GetMusic()
            }
        },

        GetMusic() {
            let music = document.getElementById("music")
            music.play()
        },

        childByValue(val) {
            this.JieShu = val
        },


        StartGroup(data) {
            this.GetVsKaiShi(data)
            if (data.game_arena_id == this.itemInfo.id) {
                this.itemInfo.status = data.status
            }

        },


        OpenXZshow() {
            this.XZshow = true
        },

        CloseXZshow() {
            this.XZshow = false
        },


        Refresh() {
            this.ArrIndex = this.ArrIndex.map(item => {
                return item + 1
            })
        },

       
        SelectItem(item, index) {
			if (item.Select) {
				delete item.Select
				this.$refs.Select[index].style.border = "1px solid transparent";
			} else {
				let key = "Select";
				let value = true
				item[key] = value
				this.$refs.Select[index].style.border = "1px solid #E9B10E"
			}
			this.TotalPriceCal()
		},

        Select_All(){
            for (let i = 0; i < this.Treasure_box_prize.length; i++) {
				let key = "Select"
				let value = true
				this.Treasure_box_prize[i][key] = value
				setTimeout(() => {
					this.$refs.Select[i].style.border = "1px solid #E9B10E"
				}, 10)

			}
			this.TotalPriceCal();
        },
        ///总价值
        TotalPriceCal() {
            this.JiaZhi = 0;
            let A_Arr = this.Treasure_box_prize.filter((v) => {
				return v.Select == true
			})
			for (let k = 0; k < A_Arr.length; k++) {
				this.JiaZhi += Number(A_Arr[k].bean)
			}

        },

        ///放弃
		Postcash() {
			let HSArr = this.Treasure_box_prize.filter((i) => {
				return i.Select == true
			})
			let data = []
			for (let i = 0; i < HSArr.length; i++) {
				data[i] = {
					id: HSArr[i].id,
				}
			}
            console.log(data);
			Arena_Recover(JSON.stringify(data)).then((res) => {
				this.$message({
					message: '放弃成功',
					type: 'success'
				})
				this.GetPersonalInfo();
				this.CloseXZshow();
			})
		},
        GetPersonalInfo() {
			PersonalInfo().then((res) => {
				this.User(res.data.message)
			})
		},

        ...mapMutations([
            'User'
		]),

        ...mapActions([
            'GetVsKaiShi',
            'GetVsJieShu',
            'GetJieShuVsData',
        ])
    },

    computed: {
        ...mapState([
            'user',
            'AddInformation',
            'roundNum',
            'JieShuVsData'
        ])
    },

    watch: {
        RouterId(val) {
            this.GetArena_Detail()
        },

        JieShu(val) {
            if (val == '结束') {
                this.$route.query.Code = 2
                this.GetArena_Detail()
            }
        },

        AddInformation(val) {
            if (val.game_arena_id == this.$route.query.id) {
                this.ItemArr[Number(val.seat)] = val
                this.Refresh()
            }
        },

        JieShuVsData(val) {
            if (val.id == this.$route.query.id) {
                this.GameState = '1'
                this.game_arena_data = val
                this.itemInfo.status = val.status
            }
        }
    },

    components: {
        OpenCase
    }
}
</script>

<style lang="scss">
.VsBox-box {
    width: 100%;
    display: flex;

    //margin: 10px auto;
    .detail_left {
        width: 1076px;
        padding-bottom: 18px;
        background: rgb(22, 25, 36);
        border-radius: 10px;
        overflow: hidden;

        .title {
            display: flex;
            height: 58px;
            align-items: center;
            padding: 0 45px;
            justify-content: space-between;
            background: url(../../assets/images/battlePage/battleVS_title.png);
            background-position: 50%;
            background-repeat: no-repeat;
            background-size: 100% 100%;

            .left_title {
                display: flex;
                align-items: center;

                ///返回按钮
                .back {
                    cursor: pointer;
                    width: 79px;
                    height: 47px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background-image: url(../../assets/images/battlePage/battleVS_title_back_btn.png);
                    background-position: 50%;
                    background-repeat: no-repeat;
                    background-size: 100% 100%;

                    img {
                        width: 15px;
                        height: 13px;
                        margin-right: 5px;
                    }
                }

                ///房间编号
                .room_num {
                    flex: none;
                    font-size: 16px;
                    color: #878b91;
                    margin-left: 15px;

                    span {
                        font-family: "Oxanium";
                    }

                }
            }
        }

        .open_box_list {
            margin-top: 30px;
            display: flex;
            justify-content: center;

            .open_box {
                position: relative;
                width: 100px;
                height: 100px;
                display: flex;
                justify-content: center;
                margin: 0 18px;
                cursor: pointer;

                &:last-child {
                    &::after {
                        display: none;
                    }
                }

                ///绘制宝箱之间的点
                &::after {
                    content: "";
                    position: absolute;
                    width: 24px;
                    height: 2px;
                    background-image: url(../../assets/images/battlePage/box_dot.png);
                    background-position: 50%;
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                    right: -30%;
                    top: 50%;
                    transform: translateY(-50%);
                }

                &.end1 {
                    &::before {
                        content: "";
                        width: 85px;
                        height: 48px;
                        position: absolute;
                        z-index: 3;
                        top: 23%;
                        background-image: url(../../assets/images/battlePage/box_over.png);
                        background-position: 50%;
                        background-repeat: no-repeat;
                        background-size: 100% 100%
                    }

                    .box {
                        -webkit-filter: grayscale(100%);
                        filter: grayscale(100%);
                        -webkit-filter: grey;
                        filter: gray
                    }
                }

                .box {
                    position: relative;
                    z-index: 2;

                    img {
                        max-width: 91px;
                        max-height: 93px;
                        object-fit: contain;
                    }
                }
            }
        }
    }

    .award_show {
        width: 618px;
        min-width: 618px;
        border-radius: 10px;
        background: rgb(22, 25, 36);
        overflow: hidden;
        align-content: center;
        .title {
            height: 48px;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: #1a162a;


            span {
                font-size: 16px;
                color: #fff;
                text-shadow: 0 0 2px #db00ff, 0 0 6px #8000ff, 0 0 2px #9712ff;
                position: relative;
                z-index: 2;
            }
        }

        .btn_ok {
            height: 48px;
            display: flex;
            justify-content: center;
            align-items: center;

            .btn {
                width: 110px;
                height: 30px;
                cursor: pointer;
                display: flex;
                justify-content: center;
                align-items: center;
                color: #ffffff;
                background-image: linear-gradient(90deg, #6f5a39, #6f4c2c);
                background-blend-mode: normal, normal;
                border-radius: 4px;
                border: 1px solid #dcae64;
                user-select: none;

                &:hover {
                    background-image: linear-gradient(90deg, #6f5a39, #47321d);
                }

                &:first-child {
                    margin-right: 6px;
                }

                p {
                    font-size: 14px;
                }
            }

        }

        .product_list {
            display: flex;
            flex-wrap: wrap;
            overflow-y: auto;
            overflow-x: hidden;
            //align-content: flex-start;
            justify-content: center;
            align-content: center;
            margin: 2px;
            &::-webkit-scrollbar {
                width: 4px;
            }

            &::-webkit-scrollbar-track {
                background: #2b2341;
                border-radius: 3px
            }

            &::-webkit-scrollbar-thumb {
                background: #1b357c;
                border-radius: 3px
            }

            .product {
                width: 149px;
                height: 132px;
                position: relative;
                padding-top: 35px;
                margin: 2px 2px;
                align-content: center;
                &.lv1 {
                    background: url(../../assets/images/Roll/LV1.png) no-repeat center;
                    background-size: 100% 100%;
                }

                &.lv2 {
                    background: url(../../assets/images/Roll/LV2.png) no-repeat center;
                    background-size: 100% 100%;
                }

                &.lv3 {
                    background: url(../../assets/images/Roll/LV2.png) no-repeat center;
                    background-size: 100% 100%;
                }

                &.lv4 {
                    background: url(../../assets/images/Roll/LV3.png) no-repeat center;
                    background-size: 100% 100%;
                }

                &.lv5 {
                    background: url(../../assets/images/Roll/LV3.png) no-repeat center;
                    background-size: 100% 100%;
                }

                .MBX {
                    width: 100px;
                    position: absolute;
                    left: -5px;
                    top: 0px;
                    font-size: 10px;
                    color: #cbccd5;

                    p {
                        font-size: 10px;
                        color: #FFD077;
                        display: flex;
                        align-items: center;
                        font-family: 'Oxanium';

                        img {
                            width: 18px;
                            height: 18px;
                            vertical-align: middle;
                            margin: 0 1px 4px 0;
                        }
                    }
                }

                .tag {
                    position: absolute;
                    left: 98px;
                    top: 12px;
                    font-size: 10px;
                    color: #cbccd5;
                }

                .product_img {
                    width: 85%;
                    height: 64%;
                    margin: 0 auto;
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    img {
                        max-width: 100%;
                        max-height: 100%;
                    }
                }

                p {
                    width: 75%;
                    margin: 10px auto;
                    font-size: 12px;
                    color: #878b91;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;

                }
            }
        }
    }

    .detail_right {
        width: 314px;
        height: 930px;
        margin-left: 10px;
        border-radius: 10px;
        background: rgb(22, 25, 36);
        padding-bottom: 20px;
        overflow: hidden;
        align-self: baseline;

        .title {
            height: 58px;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: #1a162a;

            span {
                font-size: 14px;
                color: #fff;
                text-shadow: 0 0 2px #db00ff, 0 0 6px #8000ff, 0 0 2px #9712ff;
                position: relative;
                z-index: 2;
            }
        }

        .product_list {
            display: flex;
            flex-wrap: wrap;
            height: 795px;
            overflow-y: auto;
            overflow-x: hidden;
            margin-right: 5px;
            padding-left: 7px;
            align-content: flex-start;

            &::-webkit-scrollbar {
                width: 4px;
            }

            &::-webkit-scrollbar-track {
                background: #2b2341;
                border-radius: 3px
            }

            &::-webkit-scrollbar-thumb {
                background: #1b357c;
                border-radius: 3px
            }

            .product {
                width: 149px;
                height: 132px;
                position: relative;
                padding-top: 35px;

                &.lv1 {
                    background: url(../../assets/images/Roll/LV1.png) no-repeat center;
                    background-size: 100% 100%;
                }

                &.lv2 {
                    background: url(../../assets/images/Roll/LV2.png) no-repeat center;
                    background-size: 100% 100%;
                }

                &.lv3 {
                    background: url(../../assets/images/Roll/LV2.png) no-repeat center;
                    background-size: 100% 100%;
                }

                &.lv4 {
                    background: url(../../assets/images/Roll/LV3.png) no-repeat center;
                    background-size: 100% 100%;
                }

                &.lv5 {
                    background: url(../../assets/images/Roll/LV3.png) no-repeat center;
                    background-size: 100% 100%;
                }

                .MBX {
                    width: 100px;
                    position: absolute;
                    left: -5px;
                    top: 0px;
                    font-size: 10px;
                    color: #cbccd5;

                    p {
                        font-size: 10px;
                        color: #FFD077;
                        display: flex;
                        align-items: center;
                        font-family: 'Oxanium';

                        img {
                            width: 18px;
                            height: 18px;
                            vertical-align: middle;
                            margin: 0 1px 4px 0;
                        }
                    }
                }

                .tag {
                    position: absolute;
                    left: 98px;
                    top: 12px;
                    font-size: 10px;
                    color: #cbccd5;
                }

                .product_img {
                    width: 85%;
                    height: 64%;
                    margin: 0 auto;
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    img {
                        max-width: 100%;
                        max-height: 100%;
                    }
                }

                p {
                    width: 75%;
                    margin: 10px auto;
                    font-size: 12px;
                    color: #878b91;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;

                }
            }
        }
    }

    .VS-core {
        width: 100%;
        margin-top: 20px;
        display: flex;
        position: relative;
        overflow: hidden;
    }

    .wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
    }

    .Show_box {
        width: 1200px;
        padding: 10px;
        box-sizing: border-box;
        border-radius: 10px;
        margin: 0 auto 0;
        position: relative;
        top: -80px;
        text-align: center;

        .Show_title {
            text-align: center;
            font-size: 18px;
        }

        .Show_Tips {
            margin-top: 6px;
            text-align: center;
            font-size: 15px;
            color: rgb(240, 204, 1);
        }

        .Show_list {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;

            .Show_item {
                width: 2.2rem;
                margin-left: 2px;
                margin-right: 6px;
                text-align: center;
                background: url(../../assets/images/Roll/LV1.png) no-repeat center;
                background-size: 100% 100%;
                border-radius: 4px;
                cursor: pointer;

                &.lv1 {
                    background: url(../../assets/images/Roll/LV1.png) no-repeat center;
                    background-size: 100% 100%;
                }

                &.lv2 {
                    background: url(../../assets/images/Roll/LV2.png) no-repeat center;
                    background-size: 100% 100%;
                }

                &.lv3 {
                    background: url(../../assets/images/Roll/LV2.png) no-repeat center;
                    background-size: 100% 100%;
                }

                &.lv4 {
                    background: url(../../assets/images/Roll/LV3.png) no-repeat center;
                    background-size: 100% 100%;
                }

                &.lv5 {
                    background: url(../../assets/images/Roll/LV3.png) no-repeat center;
                    background-size: 100% 100%;
                }

                .info {
                    width: 100%;
                    height: 0.5rem;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 0 0.1rem;
                    box-sizing: border-box;

                    .jiage {
                        width: 50%;
                        height: 100%;
                        display: flex;
                        align-items: center;

                        img {
                            width: 0.2rem;
                            height: 0.2rem;
                            vertical-align: middle;
                        }

                        p {
                            font-size: 0.15rem;
                            color: #5AE9D3;
                        }
                    }

                    .kucun {
                        font-size: 0.14rem;
                        line-height: 0.5rem;
                        color: #808FA4;
                    }
                }

                .pic_bj {
                    position: absolute;
                    width: 1.7rem;
                    height: 1.5rem;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background-size: cover;
                    left: 0.15rem;
                    top: 0.5rem;

                    img {
                        vertical-align: middle;
                        max-width: 80%;
                        max-height: 80%;
                    }
                }

                .pic {
                    width: 1.7rem;
                    height: 1.5rem;
                    margin: 0 auto;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background-size: cover;
                    position: relative;
                    z-index: 1;

                    img {
                        vertical-align: middle;
                        max-width: 80%;
                        max-height: 80%;
                    }
                }

                .item-data {
                    width: 100%;
                    padding: 0.05rem;
                    box-sizing: border-box;
                    text-align: center;

                    .name {
                        margin-bottom: 6px;
                        font-size: 0.14rem;
                        color: #fff;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }

                }

                .box_xian {
                    width: 0.77rem;
                    height: 0.04rem;
                    background: transparent;
                    margin: 0.2rem auto 0;
                }


            }

        }

        .Show_btns {
            display: flex;
            text-align: center;
            justify-content: center;
            margin-top: 6px;

            .glod {
                width: 160px;
                height: 40px;
                cursor: pointer;
                display: flex;
                justify-content: center;
                align-items: center;
                color: #DFB057;
                background-image: linear-gradient(90deg, #6f5a39, #6f4c2c);
                background-blend-mode: normal, normal;
                border-radius: 8px;
                border: 1px solid #dcae64;
                user-select: none;
                transition: all .3s ease;
                font-weight: 600;

                &:hover {
                    background-image: linear-gradient(90deg, #6f5a39, #47321d);
                }

                p {
                    font-size: 0.16rem;

                }
            }
        }
    }

}
</style>
